// import {
//     Box,
//     Flex,
//     HStack,
//     Image,
//     SimpleGrid,
//     Text,
//     useColorModeValue,
//     VStack,
// } from '@chakra-ui/react';
// import { useEffect, useState } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
// import { ProfileConatiner } from '../../../components/LandingPageComponents/styles/SplashStyles';
// import { backbtn } from './Icons';
// import ImagePlaceholder from '../../../assets/ImagePlaceholder.jpg';
// import { useSelector } from 'react-redux';
// import { Backbutton } from 'components/LandingPageComponents/styles/HeaderStyles';
// import { ArrowDownIcon, ArrowUpIcon } from '@chakra-ui/icons';
// import WalletHistoryPrice from 'components/Wallet/WalletHistoryPrice';
// import useGetUserDetails from 'hooks/useGetUserDetail';

// const generateSalesData = ({ commision, revenue, returns, payouts }) => {
//     return [
//         {
//             id: 1,
//             title: 'Revenue Generated',
//             value: <WalletHistoryPrice price={revenue || 0} />,
//             compareText: 'Compared to',
//             compareValue: '(N0 last year)',
//             change: 'increase',
//             percentChange: 36.3,
//         },
//         {
//             id: 2,
//             title: 'Earned Commission',
//             value: <WalletHistoryPrice price={commision || 0} />,
//             compareText: 'Compared to',
//             compareValue: '(N0 last year)',
//             change: 'increase',
//             percentChange: 25.7,
//         },
//         // {
//         //     id: 3,
//         //     title: 'Returns',
//         //     value: formatCurrency(returns || 0),
//         //     compareText: 'Compared to',
//         //     compareValue: '(N5,200 last year)',
//         //     change: 'decrease',
//         //     percentChange: 96.2,
//         // },
//         {
//             id: 4,
//             title: 'Pending Payouts',
//             value: <WalletHistoryPrice price={payouts || 0} />,
//             compareText: 'Amount yet to be',
//             compareValue: 'received',
//             change: 'none',
//             percentChange: 0,
//         },
//     ];
// };

// const PerformanceEarning = () => {
//     const location = useLocation();
//     const navigate = useNavigate();

//     const walletReducer = useSelector((state) => state.walletReducer);
//     const { wallet } = walletReducer;

//     let title = location.pathname;
//     var array = title.split('/');

//     var decoded = useGetUserDetails();
//     const details = decoded?.flattenedUser?.attributes;

//     const userLogo = details?.partner_imgage;

//     const [salesData, setSalesData] = useState([]);

//     useEffect(() => {
//         // Simulate fetching data
//         const data = generateSalesData({
//             commision: wallet?.lifetime_commision,
//             revenue: wallet?.lifetime_sales_value,
//             payouts: wallet?.lifetime_payout,
//         });
//         setSalesData(data);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, []);

//     return (
//         <ProfileConatiner>
//             <HStack justify="start" alignItems="center" display={'flex'}>
//                 <Backbutton onClick={() => navigate(-1)}>{backbtn}</Backbutton>
//                 <div className="menuSection">
//                     <Text fontSize="18px">
//                         {array[array.length - 1] === 'performance' && 'Performance & Earning'}
//                     </Text>
//                 </div>
//                 <div></div>
//             </HStack>

//             <Flex w="full" h="full" justify="center" alignItems="center" flexDir="column">
//                 <VStack mt="30px">
//                     <Text textAlign="center" fontSize="14px" mb="10px">
//                         Your Agent ID <br />
//                         <b>{details?.attributes?.agent_id || 'TAJ-4626'}</b>
//                     </Text>
//                     <Image
//                         src={userLogo || ImagePlaceholder}
//                         w="64px"
//                         h="64px"
//                         borderRadius="50%"
//                     />
//                 </VStack>

//                 <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6} mt="40px">
//                     {salesData.map((item) => (
//                         <StatCard key={item.id} data={item} />
//                     ))}
//                 </SimpleGrid>
//             </Flex>
//         </ProfileConatiner>
//     );
// };

// export default PerformanceEarning;
// const StatCard = ({ data }) => {
//     const bgColor = useColorModeValue('white', 'gray.700');
//     const borderColor = useColorModeValue('gray.200', 'gray.600');

//     return (
//         <Box
//             p={4}
//             bg={bgColor}
//             borderWidth="1px"
//             borderColor={borderColor}
//             borderRadius="md"
//             shadow="sm"
//             position="relative"
//             h="full">
//             <Flex justifyContent="start" alignItems="center" mb={2}>
//                 <Text fontSize="md" fontWeight="medium" color="gray.600">
//                     {data.title}
//                 </Text>
//                 {data.change !== 'none' && (
//                     <>
//                         {data.change === 'increase' ? (
//                             <ArrowUpIcon color={'green.400'} boxSize={4} />
//                         ) : (
//                             <ArrowDownIcon color={'red.400'} boxSize={4} />
//                         )}
//                     </>
//                 )}
//             </Flex>

//             <Text fontSize="2xl" fontWeight="bold" mb={2}>
//                 {data.value}
//             </Text>

//             <Flex direction="column" fontSize="sm" color="gray.500">
//                 <Text>{data.compareText}</Text>
//                 <Text>{data.compareValue}</Text>
//             </Flex>
//         </Box>
//     );
// };

/* eslint-disable react-hooks/exhaustive-deps */
import { useMemo, memo } from 'react';
import {
    Box, Flex, HStack, Text, Heading, Image, SimpleGrid, Skeleton,
} from '@chakra-ui/react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import WalletHistoryPrice from 'components/Wallet/WalletHistoryPrice';
import useGetUserDetails from 'hooks/useGetUserDetail';
import ImagePlaceholder from '../../../assets/ImagePlaceholder.jpg';
import { ProfileConatiner } from '../../../components/LandingPageComponents/styles/SplashStyles';

/* ─────────────────────────────────────────────────────────────
   BRAND TOKENS
   ───────────────────────────────────────────────────────────── */
const NAVY        = '#1B3B5F';
const INK         = '#1A2740';
const MUTED       = '#5A6B7E';
const FAINT       = '#8896AE';
const SURFACE     = '#FFFFFF';
const SURFACE_ALT = '#F7F9FB';
const BORDER      = '#E8EDF5';
const SUCCESS     = '#10B981';
const DANGER      = '#E53E3E';

const FONT      = "'Bricolage Grotesque', sans-serif";
const SHADOW_SM = '0 1px 3px rgba(27,59,95,0.06)';

/* ─────────────────────────────────────────────────────────────
   ICONS
   ───────────────────────────────────────────────────────────── */
const BackArrowIcon = (props) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" {...props}>
        <path d="M19 12H5M12 19l-7-7 7-7"
            stroke="currentColor" strokeWidth="2.2"
            strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const ArrowUp = (props) => (
    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" {...props}>
        <path d="M12 19V5M5 12l7-7 7 7"
            stroke="currentColor" strokeWidth="2.4"
            strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const ArrowDown = (props) => (
    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" {...props}>
        <path d="M12 5v14M5 12l7 7 7-7"
            stroke="currentColor" strokeWidth="2.4"
            strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const TrendingIcon = (props) => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" {...props}>
        <path d="M23 6l-9.5 9.5-5-5L1 18M17 6h6v6"
            stroke="currentColor" strokeWidth="2"
            strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const CoinsIcon = (props) => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" {...props}>
        <circle cx="8" cy="8" r="6" stroke="currentColor" strokeWidth="2" />
        <path d="M18.09 10.37A6 6 0 1115.61 21.66M7 6h1v4M16.71 13.88l.71.71-3.18 3.18"
            stroke="currentColor" strokeWidth="2"
            strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const ClockIcon = (props) => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" {...props}>
        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
        <path d="M12 6v6l4 2"
            stroke="currentColor" strokeWidth="2"
            strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

/* ─────────────────────────────────────────────────────────────
   AGENT IDENTITY STRIP — same as other pages
   ───────────────────────────────────────────────────────────── */

const AgentIdentityStrip = ({ imageUrl, agentId }) => (
    <Flex
        align="center"
        gap="16px"
        p="14px"
        bg={SURFACE}
        border="1px solid"
        borderColor={BORDER}
        borderRadius="10px"
        mb="20px"
    >
        <Image
            src={imageUrl || ImagePlaceholder}
            w="56px"
            h="56px"
            borderRadius="50%"
            objectFit="cover"
            border="2px solid"
            borderColor={SURFACE_ALT}
            flexShrink={0}
        />
        <Box flex="1" minW="0">
            <Text
                fontSize="10.5px"
                color={FAINT}
                fontWeight="700"
                letterSpacing="0.06em"
                textTransform="uppercase"
                mb="2px"
            >
                Agent ID
            </Text>
            <Text
                fontSize="14px"
                color={INK}
                fontWeight="800"
                fontFamily={FONT}
                noOfLines={1}
            >
                {agentId || '—'}
            </Text>
        </Box>
    </Flex>
);

/* ─────────────────────────────────────────────────────────────
   TREND BADGE — small visual indicator next to value
   ───────────────────────────────────────────────────────────── */

const TrendBadge = memo(function TrendBadge({ direction, percent }) {
    if (!direction || direction === 'none') return null;

    const isUp = direction === 'increase';
    const color = isUp ? SUCCESS : DANGER;
    const bg = isUp ? '#ECFDF5' : '#FEF2F2';

    return (
        <Flex
            align="center"
            gap="3px"
            bg={bg}
            color={color}
            px="6px"
            py="2px"
            borderRadius="5px"
            fontSize="10px"
            fontWeight="800"
            fontFamily={FONT}
            flexShrink={0}
        >
            {isUp ? <ArrowUp /> : <ArrowDown />}
            <Text as="span" lineHeight="1">{percent}%</Text>
        </Flex>
    );
});

/* ─────────────────────────────────────────────────────────────
   STAT CARD
   ───────────────────────────────────────────────────────────── */

const StatCard = memo(function StatCard({
    title, price, icon, iconBg, iconColor,
    trendDirection, trendPercent, helper,
    isLoading, isPrimary,
}) {
    return (
        <Box
            p={{ base: '16px', md: '20px' }}
            bg={SURFACE}
            border="1px solid"
            borderColor={isPrimary ? NAVY : BORDER}
            borderRadius="12px"
            boxShadow={isPrimary ? '0 4px 16px rgba(27,59,95,0.08)' : SHADOW_SM}
            position="relative"
            transition="all 0.2s ease"
            _hover={{
                borderColor: isPrimary ? NAVY : '#C5D0DF',
            }}
            fontFamily={FONT}
        >
            {/* Top row — icon + title + trend */}
            <Flex align="center" justify="space-between" mb="14px" gap="10px">
                <Flex align="center" gap="10px" minW="0">
                    <Flex
                        align="center"
                        justify="center"
                        w="28px"
                        h="28px"
                        bg={iconBg}
                        color={iconColor}
                        borderRadius="7px"
                        flexShrink={0}
                    >
                        {icon}
                    </Flex>
                    <Text
                        fontSize="12.5px"
                        color={MUTED}
                        fontWeight="700"
                        noOfLines={1}
                    >
                        {title}
                    </Text>
                </Flex>
                <TrendBadge direction={trendDirection} percent={trendPercent} />
            </Flex>

            {/* Value */}
            {isLoading ? (
                <Skeleton
                    h={{ base: '26px', md: '32px' }}
                    w="65%"
                    mb="10px"
                    borderRadius="6px"
                    startColor={SURFACE_ALT}
                    endColor={BORDER}
                />
            ) : (
                <Box
                    fontSize={{ base: '22px', md: '26px' }}
                    fontWeight="800"
                    color={INK}
                    fontFamily={FONT}
                    letterSpacing="-0.02em"
                    lineHeight="1.1"
                    mb="10px"
                >
                    <WalletHistoryPrice price={price || 0} />
                </Box>
            )}

            {/* Helper text */}
            {isLoading ? (
                <Skeleton
                    h="11px"
                    w="50%"
                    borderRadius="4px"
                    startColor={SURFACE_ALT}
                    endColor={BORDER}
                />
            ) : (
                <Text fontSize="11.5px" color={FAINT} lineHeight="1.4">
                    {helper}
                </Text>
            )}
        </Box>
    );
});

/* ─────────────────────────────────────────────────────────────
   MAIN — PERFORMANCE & EARNINGS PAGE
   ───────────────────────────────────────────────────────────── */

const PerformanceEarning = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const walletReducer = useSelector((state) => state.walletReducer);
    const { wallet, loading: walletLoading } = walletReducer || {};

    const { flattenedUser } = useGetUserDetails() || {};
    const details = flattenedUser?.attributes;

    /* Derive stats directly from wallet — no useState/useEffect needed */
    const stats = useMemo(() => [
        {
            id: 'revenue',
            title: 'Revenue generated',
            price: wallet?.lifetime_sales_value,
            helper: 'Total revenue earned from all sales',
            icon: <TrendingIcon />,
            iconBg: '#ECFDF5',
            iconColor: SUCCESS,
            trendDirection: 'increase',
            trendPercent: 36.3,
            isPrimary: true,
        },
        {
            id: 'commission',
            title: 'Earned commission',
            /* Note: backend field is misspelled `lifetime_commision` */
            price: wallet?.lifetime_commision,
            helper: 'Commission earned from completed sales',
            icon: <CoinsIcon />,
            iconBg: '#FFF7E6',
            iconColor: '#D97706',
            trendDirection: 'increase',
            trendPercent: 25.7,
        },
        {
            id: 'payouts',
            title: 'Pending payouts',
            price: wallet?.lifetime_payout,
            helper: 'Amount yet to be received',
            icon: <ClockIcon />,
            iconBg: SURFACE_ALT,
            iconColor: MUTED,
            trendDirection: 'none',
            trendPercent: 0,
        },
    ], [wallet]);

    return (
        <ProfileConatiner>
            <Box
                maxW="780px"
                mx="auto"
                w="full"
                px={{ base: '12px', md: '20px' }}
                py={{ base: '8px', md: '12px' }}
                fontFamily={FONT}
            >
                {/* HEADER */}
                <HStack spacing="8px" align="center" mb="14px">
                    <Box
                        as="button"
                        onClick={() => navigate(-1)}
                        h="32px"
                        w="32px"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        borderRadius="7px"
                        color={MUTED}
                        cursor="pointer"
                        bg="transparent"
                        border="none"
                        transition="all 0.15s ease"
                        _hover={{ bg: SURFACE_ALT, color: NAVY }}
                        _focusVisible={{
                            outline: `2px solid ${NAVY}`,
                            outlineOffset: '2px',
                        }}
                        aria-label="Go back"
                    >
                        <BackArrowIcon />
                    </Box>
                    <Heading
                        as="h1"
                        fontSize={{ base: '17px', md: '19px' }}
                        fontWeight="800"
                        color={INK}
                        fontFamily={FONT}
                        letterSpacing="-0.02em"
                    >
                        Performance & earnings
                    </Heading>
                </HStack>

                {/* AGENT IDENTITY */}
                <AgentIdentityStrip
                    imageUrl={details?.partner_imgage}
                    agentId={details?.agent_id}
                />

                {/* STATS GRID */}
                <SimpleGrid
                    columns={{ base: 1, md: 2 }}
                    spacing={{ base: '12px', md: '14px' }}
                >
                    {/* Revenue takes both columns on desktop — primary metric */}
                    <Box gridColumn={{ md: '1 / -1' }}>
                        <StatCard
                            {...stats[0]}
                            isLoading={walletLoading}
                        />
                    </Box>

                    {/* Commission + Payouts side by side */}
                    <StatCard {...stats[1]} isLoading={walletLoading} />
                    <StatCard {...stats[2]} isLoading={walletLoading} />
                </SimpleGrid>

                {/* Empty state — shown when wallet exists and all values are 0 */}
                {!walletLoading && wallet && (
                    Number(wallet?.lifetime_sales_value) === 0 &&
                    Number(wallet?.lifetime_commision) === 0 &&
                    Number(wallet?.lifetime_payout) === 0
                ) && (
                    <Box
                        mt="20px"
                        bg={SURFACE}
                        border="1px dashed"
                        borderColor={BORDER}
                        borderRadius="12px"
                        p="24px"
                        textAlign="center"
                    >
                        <Text fontSize="13px" color={MUTED} fontWeight="600" mb="4px">
                            No sales activity yet
                        </Text>
                        <Text fontSize="12px" color={FAINT}>
                            Once you complete your first sale, your performance metrics will appear here.
                        </Text>
                    </Box>
                )}
            </Box>
        </ProfileConatiner>
    );
};

export default PerformanceEarning;